import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { PhameeService } from 'src/app/services/phamee.service';

@Component({
  selector: 'smart-manage-farm-list',
  templateUrl: './manage-farm-list.component.html',
  styleUrls: ['./manage-farm-list.component.scss','../../platform-color/platform-color.css']
})
export class ManageFarmListComponent implements OnInit {
  form: FormGroup;
  loadFarm: boolean = false;

  farmListAll = [];
  farmList = [];
  systemRole: string;
  
  constructor(
    private formBuilder: FormBuilder,
    private PhameeService: PhameeService,
    private spinner: NgxSpinnerService,

    private cd: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.systemRole = sessionStorage.getItem('system_role');
    this.createForm();
    this.getFarmList();
  }

  createForm(){
    this.form = this.formBuilder.group({
      farm_name: [""],
    });
  }

  search(){
    if(this.form.value.farm_name){
      this.farmList = this.farmListAll.filter(farm=> farm.name.includes(this.form.value.farm_name));

      this.cd.detectChanges();
    }else{
      this.getFarmList();
    }
  }

  getFarmList(){
    this.loadFarm = false;
    this.spinner.show();

    this.PhameeService.getDropdownDashboard().subscribe(res=>{
      
      this.farmListAll = res.data.FarmList;
      this.farmList = res.data.FarmList;

      this.farmList.map(farm=>{
        if(farm._id){
          this.PhameeService.getPlotDashboard(farm._id).subscribe(plot=>{
            if(plot.data){
              farm['number_of_plot'] = plot.data.plot.length || 0;
            }else{
              farm['number_of_plot'] = 0;
            }
            this.cd.detectChanges();
          })
        }
      })
      this.spinner.hide();
      this.loadFarm = true;
    })
  }
}
